window.TechTrackModel = class TechTrackModel {
    constructor (map, routingHelper) {
        this.map = map;
        this.routingHelper = routingHelper;

        this.stopLastTransition = () => {};
        this.lastUpdateEstimatesDate = null;
        this.lastApplyDate = null;
        this.token = null;

        this.Customer = ko.observable();
        this.CompanyName = ko.observable();

        this.Technician = {
            id: 0,
            name: ko.observable(),
            photo: ko.observable(),
            tenant: ko.observable(),
            phone: ko.observable(),
            phoneUrl: ko.observable(),
            coords: ko.observable(),
            techStarRating: {
                starRating: ko.observable(),
                starCount: ko.observable(),
                reviewCount: ko.observable()
            }
        };

        this.Target = {
            address: ko.observable(),
            coords: ko.observable()
        };

        this.Arrival = {
            arrived: ko.observable(),
            estimatedDistance: ko.observable(),
            estimatedTime: ko.observable()
        };
    }

    async initialize(data) {
        await this.map.initialize('map');
        
        this.subscribeOnChanges();

        this._setData(data);

        this.map.center();
        this.bindPusher();
    }
    
    subscribeOnChanges() {
        this.Target.coords.subscribe(this.map.updateTargetMarker.bind(this.map));
        this.Technician.coords.subscribe(this.map.updateTechnicianMarker.bind(this.map));

        this.Target.coords.subscribe(this.updateEstimates.bind(this));
        this.Technician.coords.subscribe(this.updateEstimates.bind(this));

        this.Arrival.arrived.subscribe((arrived) => {
            if (arrived) {
                this.stopLastTransition();
                this.map.updateTargetMarker(null);
                this.map.updateTechnicianMarker(this.Target.coords(), this.map.technicianArrivedImg);
            } else {
                this.map.updateTargetMarker(this.Target.coords());
                this.map.updateTechnicianMarker(this.Technician.coords(), this.map.technicianImg);
            }
        });
    }

    async updateEstimates() {
        const source = this.Technician.coords();
        const target = this.Target.coords();

        if (source && target) {
            if (this.lastUpdateEstimatesDate && (Date.now() - this.lastUpdateEstimatesDate) / 1000 < 30) {
                return;
            }

            this.lastUpdateEstimatesDate = Date.now();

            const sourceStop = {
                geometry: {
                    y: source.Latitude,
                    x: source.Longitude
                }
            };

            const targetStop = {
                geometry: {
                    y: target.Latitude,
                    x: target.Longitude
                }
            };

            try {
                const result = await this.routingHelper.calculateRoute([sourceStop, targetStop]);

                const summary = result.routes.features[0].attributes;

                const distance = Math.round(summary.Total_Miles * 10) / 10;
                const time = Math.round(summary.Total_TravelTime);

                this.Arrival.estimatedDistance(distance + ' mi');
                this.Arrival.estimatedTime(time + ' mins');
            } catch (e) {
                console.log(e)
            }
        }
        else {
            this.Arrival.estimatedDistance('');
            this.Arrival.estimatedTime('');
        }
    }

    async applyPositionBatch(positions, speed) {
        const coords = this.Technician.coords();
        const lastPosition = _.last(positions);

        if (!coords) {
            this._setTechnicianCoords(lastPosition);
            return;
        }

        this.stopLastTransition();

        const distance = TechTrackUtils.getDistance(coords.Latitude, coords.Longitude, lastPosition.Latitude, lastPosition.Longitude);

        speed = speed || 60; //km/h
        speed += 20; //to reduce gap with real data

        if (distance === 0) {
            return;
        }

        if (distance > 150) {
            this._setTechnicianCoords(lastPosition);
            return;
        }

        let cancellationToken = { isCancelled: false };

        this.stopLastTransition = () => cancellationToken.isCancelled = true;

        for (const position of positions) {
            await this.applyCoordsImitatingCar(position, speed, cancellationToken)
        }
    };

    async applyCoordsImitatingCar(coords, speed, cancellationToken) {
        if (cancellationToken.isCancelled) {
            return;
        }
        
        const currentCoords = this.Technician.coords();
        let currentLat = currentCoords.Latitude;
        let currentLng = currentCoords.Longitude;

        const dist = TechTrackUtils.getDistance(currentLat, currentLng, coords.Latitude, coords.Longitude) ; // in meters

        if (dist === 0) {
            return;
        }

        const numStep = 100;

        const currentDate = Date.now();
        let time = this.lastApplyDate ? (currentDate - this.lastApplyDate) / 1000 : null;
        
        if (!time || time > 10) {
            time = dist / speed;
        }

        const delay = time / numStep;
        const step = dist / numStep;
        
        const deltaLat = (coords.Latitude - currentLat) / numStep;
        const deltaLng = (coords.Longitude - currentLng) / numStep;

        await this.addDeltaToCoords(dist, 0, step, deltaLat, deltaLng, coords, cancellationToken, delay);

        this.lastApplyDate = currentDate;
    };

    async addDeltaToCoords(dist, distPassed, step, deltaLat, deltaLng, coords, cancellationToken, delay) {
        if (cancellationToken.isCancelled) {
            return;
        }

        const { Latitude, Longitude } = this.Technician.coords();

        const newCoords = {
            Latitude: TechTrackUtils.calculateCoordinate(Latitude, deltaLat, coords.Latitude),
            Longitude: TechTrackUtils.calculateCoordinate(Longitude, deltaLng, coords.Longitude)
        };

        this._setTechnicianCoords(newCoords);

        if (distPassed < dist) {
            distPassed += step;
            await TechTrackUtils.sleep(delay);
            await this.addDeltaToCoords(dist, distPassed, step, deltaLat, deltaLng, coords, cancellationToken, delay);
        }
    }

    bindPusher() {
        if (window['Pusher'] === undefined)
            return;

        Pusher.channel_auth_endpoint = '/Auth/TechTrackPusherAuth?';
        if (window.App.Proxy)
            Pusher.channel_auth_endpoint = window.App.Proxy.fixParamUrl(Pusher.channel_auth_endpoint);

        const pusher = new Pusher('59831c16dcf080351f5b', {
            encrypted: true, auth: {
                headers: {
                    'token': window.TrackingInfo.Token
                }
            }
        });
        window.pusherInstance = pusher;

        pusher.connection.bind('state_change', (states) =>
            console.log('Pusher state changed:', states.current));
        
        const channel = pusher.subscribe(['private', 'techtrack', window.App.PusherNamespace, window.App.TenantId || 0].join('-'));

        channel.bind('pusher:subscription_error', (status) => 
            console.log('Pusher subscription error:', status));

        channel.bind('GpsPositionChangedEvent', data => {
            if (!data || !data.TechnicianPositions || this.Arrival.arrived())
                return;

            const positions = _.where(data.TechnicianPositions, { 'TechnicianId': this.Technician.id });

            if (!positions.length)
                return;

            let speed = data.Speed;
            if (speed > 0) {
                speed = speed * 60 * 60 / 1000;
            }

            this.applyPositionBatch(positions, speed);
        });

        channel.bind('TechnicianArrivedEvent', (data) => {
            if (data.TechnicianId === this.Technician.id) {
                this.Arrival.arrived(true);
            }
        });
    };
    
    _setTechnicianCoords(coords) {
        if (!coords || !coords.Latitude || !coords.Longitude) {
            return;
        }
        
        this.Technician.coords(coords);
    }

    _setTargetCoords(coords) {
        if (!coords || !coords.Latitude || !coords.Longitude) {
            return;
        }

        this.Target.coords(coords);
    }

    _setData(data) {
        this.token = data.Token;

        this.Customer(data.Customer);
        this.CompanyName(data.CompanyName);
        this.Technician.id = data.Technician.Id;
        this.Technician.name(data.Technician.Name);
        this.Technician.photo(data.Technician.Photo || '/Assets/Media/Icons/Track/DefaultTechnicianAvatar.png');
        this.Technician.phone(data.BusinessUnitPhone || data.Technician.Phone);
        this.Technician.phoneUrl('tel://' + (data.BusinessUnitPhone || data.Technician.Phone));
        this._setTechnicianCoords(data.Technician.Coords);

        if (data.Technician.TechStarRating) {
            this.Technician.techStarRating.starRating(data.Technician.TechStarRating.StarRating);
            this.Technician.techStarRating.starCount(data.Technician.TechStarRating.StarCount);
            this.Technician.techStarRating.reviewCount(data.Technician.TechStarRating.ReviewCount);
        }

        this.Target.address(data.Target.Address);
        this._setTargetCoords(data.Target.Coords);

        this.Arrival.arrived(data.Arrived);
    }
};


$(function () {
    const map = new TechTrackMap();

    const routingHelper = new EsriRoutingHelper({
        clientId: window.TrackingInfo.ArcgisClientId,
        clientSecret: window.TrackingInfo.ArcgisClientSecret
    });

    const model = new TechTrackModel(map, routingHelper);

    model.initialize(window.TrackingInfo).then(() => {
        ko.applyBindings(model);
    });
});
